import {showValidationErrorsModal} from "@utils/modal-manager";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";
import {ValidateStep5Data} from "@validators/business-insurance-form/step5-validator";
import {WizardStepButtonsBlock} from "@components/common/form-blocks/other/wizard-step-buttons-block";
import {TermsAgreementBlock} from "@components/common/form-blocks/other/terms-agreement-block";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";
import {PREMISE_TENURE_TYPE_OPTIONS} from "@constants/form-optins/business-insurance-options";
import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import {YES_NO_CHOICE_OPTIONS} from "@constants/dropdown-choices";
import ScrollableCustomDateTimePickerBlock
   from "@components/common/form-blocks/scrollable/custom-datetime-picker-block";

export default function IF_Step5(
   {
      data,
      handlers,
      setCurrentStep,
      onSubmit
   }) {
   
   const STEP = 5;
   
   const onPrevBtnClick = (event) => {
      setCurrentStep(STEP - 1);
   }
   
   const onNextBtnClick = async (event) => {
      
      let validationResult = ValidateStep5Data(data);
      
      if (validationResult.length) {
         
         showValidationErrorsModal({
            validationResult: validationResult
         });
         
         
      } else {
         onSubmit();
      }
      
      
   }
   
   return (
      <div className={`if-step-${STEP}`}>
         
         
         <SectionHeading
            text={"Cover details"}
         />
         
         <div className="row">
            
            {/* Is the premises’ owned / leased / rented by you? */}
            
            <ScrollableDropdownBlock
               selectedValues={data.premiseTenureType}
               controlName="premiseTenureType"
               containerCssClass="col-12 py-3"
               labelText="Is the premises owned / leased / rented by you?"
               required={true}
               options={PREMISE_TENURE_TYPE_OPTIONS}
               
               onChange={handlers.onControlChange}
               helpText=""
            />
            
            {/* Do you require buildings cover? */}
            
            <ScrollableButtonGroupBlock
               selectedValues={data.isBuildingCoverRequired}
               containerCssClass="col-12 py-3"
               labelText="Do you require buildings cover?"
               required={true}
               controlName="isBuildingCoverRequired"
               options={YES_NO_CHOICE_OPTIONS}
               
               onChange={handlers.onControlChange}
            />
            
            {/* What’s the maximum cash amount to be covered during the business hours? */}
            
            <ScrollableTextBoxBlock
               value={data.maximumCashAmountToCoverOnBusinessHours}
               containerCssClass="col-12 py-3"
               labelText="What’s the maximum cash amount to be covered during the business hours?"
               required={true}
               controlName="maximumCashAmountToCoverOnBusinessHours"
               
               onChange={handlers.onControlChange}
               asTextArea={false}
               inputAttrs={{
                  maxLength: 50,
                  type: 'number'
               }}
            />
            
            {/* Do you want any cash sum to be covered outside the premises? */}
            
            <ScrollableButtonGroupBlock
               selectedValues={data.isCashAmountCoverRequiredOutsidePremise}
               containerCssClass="col-12 py-3"
               labelText="Do you want any cash sum to be covered outside the premises?"
               required={true}
               controlName="isCashAmountCoverRequiredOutsidePremise"
               options={YES_NO_CHOICE_OPTIONS}
               
               onChange={handlers.onControlChange}
            />
            
         </div>
         
         <SectionHeading
            text={"Stocks to be insured"}
            headingCssClass={`mt-3`}
         />
         
         <div className="row">
            {/* Cigarettes, cigars and tobacco sum insured amount */}
            
            <ScrollableTextBoxBlock
               value={data.tobaccoRelatedStockInsureAmount}
               containerCssClass="col-12 py-3"
               labelText="Cigarettes, cigars and tobacco sum insured amount"
               required={false}
               controlName="tobaccoRelatedStockInsureAmount"
               
               onChange={handlers.onControlChange}
               asTextArea={false}
               inputAttrs={{
                  maxLength: 50,
                  type: 'number'
               }}
            />
            
            {/* Wines, fortified wines and spirits sum insured amount */}
            
            <ScrollableTextBoxBlock
               value={data.wineRelatedStockInsureAmount}
               containerCssClass="col-12 py-3"
               labelText="Wines, fortified wines and spirits sum insured amount"
               required={false}
               controlName="wineRelatedStockInsureAmount"
               
               onChange={handlers.onControlChange}
               asTextArea={false}
               inputAttrs={{
                  maxLength: 50,
                  type : 'number'
               }}
            />
            
            {/* Frozen items to be insured */}
            
            <ScrollableTextBoxBlock
               value={data.frozenItemRelatedStockInsureAmount}
               containerCssClass="col-12 py-3"
               labelText="Frozen items to be insured"
               required={false}
               controlName="frozenItemRelatedStockInsureAmount"
               
               onChange={handlers.onControlChange}
               asTextArea={false}
               inputAttrs={{
                  maxLength: 50,
                  type : 'number'
               }}
            />
            
            {/* Contents (fixtures & fittings) sum insured amount */}
            
            <ScrollableTextBoxBlock
               value={data.furnitureRelatedStockInsureAmount}
               containerCssClass="col-12 py-3"
               labelText="Contents (fixtures & fittings) sum insured amount"
               required={false}
               controlName="furnitureRelatedStockInsureAmount"
               
               onChange={handlers.onControlChange}
               asTextArea={false}
               inputAttrs={{
                  maxLength: 50,
                  type : 'number'
               }}
            />
            
            {/* Contents (If any till, computers & other electrical equipment) sum insured amount. */}
            
            <ScrollableTextBoxBlock
               value={data.electricalEquipmentRelatedStockInsureAmount}
               containerCssClass="col-12 py-3"
               labelText="Contents (If any till, computers & other electrical equipment) sum insured amount."
               required={false}
               controlName="electricalEquipmentRelatedStockInsureAmount"
               
               onChange={handlers.onControlChange}
               asTextArea={false}
               inputAttrs={{
                  maxLength: 50,
                  type : 'number'
               }}
            />
            
            {/* Other Stock */}
            
            <ScrollableTextBoxBlock
               value={data.otherStockInsureAmount}
               containerCssClass="col-12 py-3"
               labelText="Other Stock"
               required={false}
               controlName="otherStockInsureAmount"
               
               onChange={handlers.onControlChange}
               asTextArea={false}
               inputAttrs={{
                  maxLength: 50,
                  type: 'number'
               }}
            />
            
         </div>
         
         <SectionHeading
            text={"Claim summary"}
            headingCssClass={`mt-3`}
         />
         
         <div className="row">
            
            {/* Have you had any losses or incidents that have or could have given rise to claims (whether insured or not) in the past 5 years in connection with your current, or previous, business? */}
            
            <ScrollableButtonGroupBlock
               selectedValues={data.hadAnyClaimsBeenMadeInLast5Years}
               containerCssClass="col-12 py-3"
               labelText="Have you had any losses or incidents that have or could have given rise to claims (whether insured or not) in the past 5 years in connection with your current, or previous, business?"
               required={true}
               controlName="hadAnyClaimsBeenMadeInLast5Years"
               options={YES_NO_CHOICE_OPTIONS}
               
               onChange={handlers.onControlChange}
            />
            
         </div>
         
         <SectionHeading
            text={"Employer reference number details"}
            headingCssClass={`mt-3`}
         />
         
         <div className="row">
            
            {/* Are you exempt from paying PAYE? */}
            
            <ScrollableButtonGroupBlock
               selectedValues={data.isExemptFromPayingPAYE}
               containerCssClass="col-12 py-3"
               labelText="Are you exempt from paying PAYE?"
               required={true}
               controlName="isExemptFromPayingPAYE"
               options={YES_NO_CHOICE_OPTIONS}
               
               onChange={handlers.onControlChange}
            />
            
            {/* Please provide your employer reference number */}
            
            <ScrollableTextBoxBlock
               value={data.employerReferenceNumber}
               containerCssClass="col-12 py-3"
               labelText="Please provide your employer reference number"
               required={true}
               controlName="employerReferenceNumber"
               
               onChange={handlers.onControlChange}
               asTextArea={false}
               inputAttrs={{
                  maxLength: 50
               }}
            />
            
         </div>
         
         <SectionHeading
            text={"Policy start date"}
            headingCssClass={`mt-3`}
         />
         
         <div className="row">
            {/* When would you like your policy to start */}
            
            <ScrollableCustomDateTimePickerBlock
               value={data.policyStartDate}
               containerCssClass="col-12 py-3"
               labelText="When would you like your policy to start"
               required={true}
               controlName="policyStartDate"
               
               onChange={handlers.onControlChange}
            />
         </div>
         
            {/* Additional comments */}
         
         <div className="row">
            
            <ScrollableTextBoxBlock
               containerCssClass="col-12 py-3 "
               labelText="Additional comments"
               required={false}
               controlName="addAdditionalComments"
               value={data.addAdditionalComments}
               onChange={handlers.onControlChange}
               inputAttrs={{
                  maxLength: 1024,
                  rows: 5
               }}
               asTextArea={true}
            />
         
         </div>
         
         <TermsAgreementBlock
            controlName={"termsAgreement"}
            controlIdPrefix={"termsAgreement-"}
            required={true}
            onChange={handlers.onControlChange}
            selectedValue={data.termsAgreement}
            labelText={"Terms agreement"}
            isHidden={false}
         />
         
         
         <WizardStepButtonsBlock
            prevBtnText={"Previous"}
            onPrevBtnClick={onPrevBtnClick}
            nextBtnText={"Submit"}
            onNextBtnClick={onNextBtnClick}
            nextBtnIconClass={"fa fa-fw fa-save me-2"}
            nextBtnIconPosition={"left"}
            nextButtonAdditionalCssClass={'fixed-bottom2'}
            isNextBtnDisabled={data.termsAgreement !== 'Yes'}
         />
      
      
      </div>
   );
}